<template>
  <div>
    <g-breadcrumb
      v-if="paginaStatus.modal === false"
      :paginas="paginaStatus.caminhoMigalha"
    />
    <q-modal
      v-model="modalEditar"
      :no-backdrop-dismiss="modalEditar"
      :no-esc-dismiss="modalEditar"
      :content-css="{minWidth: '70vw'}"
    >
      <q-card-main>
        <div class="row mrg-b-10">
          <span class="titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <i class="titulo-icone fas fa-sync"></i> Atualizar requerente de acordo com o cadastro de pessoa do município
          </span>
        </div>
        <div
          class="q-card gvn-cabecalho mrg-b-10"
          v-if="this.indTipoPessoa !== 'J'"
        >
          <div class="row mrg-t-2">
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
              <strong>Nome: </strong>
              {{this.pessoaFisica.nomPessoa}}
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <strong>CPF: </strong>
              {{formatarDocumento(this.pessoaFisica.numCpf)}}
            </div>
          </div>
          <div class="row mrg-t-2">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Data de nascimento: </strong>
              {{formatarDiaMesAno(this.pessoaFisica.datNascimento)}}
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
              <strong>Sexo: </strong>
              {{this.pessoaFisica.indSexo === 'M' ? 'Masculino' : this.pessoaFisica.indSexo === 'F' ? 'Feminino' : this.pessoaFisica.indSexo === 'I' ? 'Indiferente' : ''}}
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <strong>Estado civil: </strong>
              {{this.pessoaFisica.indEstadoCivilDescricao}}
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <strong>Nacionalidade: </strong>
              {{this.pessoaFisica.nacionalidade.nomNacionalidade}}
            </div>
          </div>
          <div class="row mrg-t-2">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Telefone móvel: </strong>
              {{mascaraTelefone(this.pessoaFisica.pessoa.numTelefone1)}}
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Telefone residencial: </strong>
              {{mascaraTelefone(this.pessoaFisica.pessoa.numTelefone2)}}
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Telefone comercial: </strong>
              {{mascaraTelefone(this.pessoaFisica.pessoa.numTelefone3)}}
            </div>
          </div>
          <div class="row mrg-t-2">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <strong>Email: </strong>
              {{this.pessoaFisica.pessoa.desEmail}}
            </div>
          </div>
          <div class="row mrg-t-2">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <strong>Filiação principal: </strong>
              {{this.pessoaFisica.desFiliacaoPrimeira}}
            </div>
          </div>
        </div>
        <div
          class="q-card gvn-cabecalho mrg-b-10"
          v-else
        >
          <div class="row mrg-t-2">
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
              <strong>Nome: </strong>
              {{this.pessoaJuridica.desRazaoSocial}}
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <strong>CNPJ: </strong>
              {{formatarDocumento(this.pessoaJuridica.numCnpj)}}
            </div>
          </div>
          <div class="row mrg-t-2">
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Telefone móvel: </strong>
              {{mascaraTelefone(this.pessoaJuridica.pessoa.numTelefone1)}}
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Telefone residencial: </strong>
              {{mascaraTelefone(this.pessoaJuridica.pessoa.numTelefone2)}}
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <strong>Telefone comercial: </strong>
              {{mascaraTelefone(this.pessoaJuridica.pessoa.numTelefone3)}}
            </div>
          </div>
          <div class="row mrg-t-2">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <strong>Email: </strong>
              {{this.pessoaJuridica.pessoa.desEmail}}
            </div>
          </div>
        </div>
        <table
          class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <th
                class="text-left"
                width="1%"
              ></th>
              <th
                class="text-left"
                width="10%"
              >CEP</th>
              <th
                class="text-left"
                width="10%"
              >Tipo</th>
              <th
                class="text-left"
                width="20%"
              >Logradouro</th>
              <th
                class="text-left"
                width="10%"
              >Número</th>
              <th
                class="text-left"
                width="10%"
              >Complemento</th>
              <th
                class="text-left"
                width="15%"
              >Bairro</th>
              <th
                class="text-left"
                width="20%"
              >Município</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(mov, index) in arrayEndereco"
              v-bind:key="mov.codPessoaEndereco"
            >
              <td class="text-right">
                <q-option-group
                  color="secondary"
                  type="radio"
                  v-model="mov.enderecoSelecionado"
                  :options="[
                    { label: '', value: mov.codPessoaEndereco }
                  ]"
                  @input="atualizarEnderecoSelecionado(index)"
                  @change="atualizarEnderecoSelecionado(index)"
                  @focus="atualizarEnderecoSelecionado(index)"
                />
              </td>
              <td class="text-left">
                {{mov.codCepEndFraco}}
              </td>
              <td class="text-left">
                {{mov.indTipoEndereco}}
              </td>
              <td class="text-left">
                {{mov.nomLogradouroEndFraco}}
              </td>
              <td class="text-left">
                {{mov.numEndereco}}
              </td>
              <td class="text-left">
                {{mov.desComplemento}}
              </td>
              <td class="text-left">
                {{mov.nomBairro}}
              </td>
              <td class="text-left">
                {{mov.municipio.nomMunicipioUf}}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-sm-6 text-right mrg-t-10">
          <q-btn
            style="margin-right:5px;"
            id="Cancelar"
            name="Cancelar"
            color="black"
            @click="modalEditar = false"
            text-color="white"
            label="Cancelar"
          >
          </q-btn>
          <q-btn
            icon="check"
            id="Confirmar"
            name="Confirmar"
            color="positive"
            @click="atualizarRequerente"
            label="Confirmar"
          >
          </q-btn>
        </div>

      </q-card-main>
    </q-modal>
    <q-modal
      v-model="modalEndereco"
      :no-backdrop-dismiss="modalEndereco"
      :no-esc-dismiss="modalEndereco"
      :content-css="{minWidth: '70vw'}"
    >
      <q-card-main>
        <div class="row mrg-b-10">
          <span class="titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <i class="titulo-icone fas fa-sync"></i> Atualizar endereço requerente
          </span>
        </div>
        <q-search
          class="gvn-q-search"
          v-model="termoEnderecoRequerente"
          placeholder="Pesquisar"
          :debounce=1
          :max-length="10"
          @keyup.13="pesquisarTermo()"
          :clearable="false"
        />
        <q-layout
          class="mrg-t-10"
          container
          style="height: 400px; max-height: 400px; width: 100%"
        >
          <table
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
            cellspacing="0"
            cellpadding="0"
          >
            <thead>
              <tr>
                <th
                  class="text-left"
                  width="1%"
                ></th>
                <th
                  class="text-left"
                  width="10%"
                >CEP</th>
                <th
                  class="text-left"
                  width="10%"
                >Tipo</th>
                <th
                  class="text-left"
                  width="20%"
                >Logradouro</th>
                <th
                  class="text-left"
                  width="25%"
                >Bairro</th>
                <th
                  class="text-left"
                  width="25%"
                >Município</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(mov, index) in !this.termoEnderecoRequerente ? arrayEndereco2 : arrayEndereco2.filter(x => x.logradouro.trim().toUpperCase().includes(this.termoEnderecoRequerente.trim().toUpperCase())
                  || (x.nomBairro || x.bairro).trim().toUpperCase().includes(this.termoEnderecoRequerente.trim().toUpperCase()))"
                v-bind:key="mov.codLocalizacao"
              >
                <td class="text-right">
                  <q-option-group
                    color="secondary"
                    type="radio"
                    v-model="mov.enderecoSelecionado"
                    :options="[
                      { label: '', value: mov.codLocalizacao }
                    ]"
                    @input="atualizarEnderecoSelecionado2(index)"
                    @change="atualizarEnderecoSelecionado2(index)"
                    @focus="atualizarEnderecoSelecionado2(index)"
                  />
                </td>
                <td class="text-left">
                  {{mov.cep}}
                </td>
                <td class="text-left">
                  {{mov.tipoLogradouro}}
                </td>
                <td class="text-left">
                  {{mov.logradouro}}
                </td>
                <td class="text-left">
                  {{mov.nomBairro || mov.bairro}}
                </td>
                <td class="text-left">
                  {{mov.localidadeUf || mov.localidade + ' - ' + mov.uf}}
                </td>
              </tr>
            </tbody>
          </table>
        </q-layout>
        <div class="col-sm-6 text-right mrg-t-10">
          <q-btn
            style="margin-right:5px;"
            id="Cancelar"
            name="Cancelar"
            color="black"
            @click="limparModalEndereco()"
            text-color="white"
            label="Cancelar"
          >
          </q-btn>
          <q-btn
            icon="check"
            id="Confirmar"
            name="Confirmar"
            color="positive"
            @click="atualizarEnderecoRequerente"
            label="Confirmar"
          >
          </q-btn>
        </div>
      </q-card-main>
    </q-modal>
    <q-card>
      <q-card-main>
        <div class="row mrg-t-0">
          <div class="col-12 gvn-title-primary mrg-t-0">Dados Básicos</div>
        </div>
        <div class="row">
          <div class="col-sm-3 col-xs-3">
            <g-input
              id="refCodRequerente"
              name="refCodRequerente"
              ref="refCodRequerente"
              validacao="Number"
              etiqueta="Código"
              :foco="false"
              :desabilitar="true"
              v-model="paginaStatus.requerente.codRequerente"
            >
            </g-input>
          </div>
          <div class="col-sm-2 col-xs-2">
            <g-select
              id="refIndTipoPessoa"
              name="refIndTipoPessoa"
              ref="refIndTipoPessoa"
              etiqueta="Tipo de pessoa"
              validacao="required"
              :itens="tipoPessoaArray"
              item-valor="indTipoPessoa"
              item-etiqueta="descricao"
              :foco="true"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="indTipoPessoa"
            >
            </g-select>
          </div>
          <div
            v-if="indTipoPessoa === 'J'"
            class="col-sm-7 col-xs-7 "
          >
            <g-input
              id="refTxtDocumento"
              name="refTxtDocumento"
              mascara="cnpj"
              validacao="required | text | cnpj"
              ref="refTxtDocumento"
              etiqueta="CNPJ"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              :converter-para-maiusculo="true"
              v-model="numCnpj"
            >
            </g-input>
          </div>
          <div
            v-else-if="indTipoPessoa === 'F'"
            class="col-sm-6 col-xs-6 "
          >
            <g-input
              id="refTxtDocumento"
              name="refTxtDocumento"
              mascara="cpf"
              validacao="required | text | cpf"
              ref="refTxtDocumento"
              etiqueta="CPF"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="numCpf"
            >
            </g-input>
          </div>
          <div
            v-if="indTipoPessoa === 'F'"
            class="col-sm-1 col-xs-1 mrg-t-20"
          >
            <q-btn
              icon="fa fa-search"
              style="background: #550059 !important; color: white"
              @click="buscarDadosPessoaFisica"
            >
            </q-btn>
          </div>
          <div
            v-else
            class="col-sm-2 col-xs-2 "
          >
            <g-select
              id="refTipoDocumento"
              name="refTipoDocumento"
              ref="refTipoDocumento"
              etiqueta="Tipo de Documento"
              :itens="documentoArray"
              item-valor="tipoDocumento"
              item-etiqueta="descricao"
              :foco="false"
              validacao="required"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="tipoDocumento"
            >
            </g-select>
            <!-- <g-input
              validacao="required | text"
              ref="refTxtDocumento"
              etiqueta="Outro Documento"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="outroDocumento"
            >
            </g-input> -->
          </div>
          <div
            v-if="tipoDocumento === 'RG' && indTipoPessoa === 'O'"
            class="col-sm-5 col-xs-5 "
          >
            <g-input
              id="refTxtDocumentoOutro"
              name="refTxtDocumentoOutro"
              :tamanho="16"
              validacao="required | text"
              ref="refTxtDocumentoOutro"
              etiqueta="RG"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="numRg"
            >
            </g-input>
          </div>
          <div
            v-if="tipoDocumento === 'NIS' && indTipoPessoa === 'O'"
            class="col-sm-5 col-xs-5 "
          >
            <g-input
              id="refTxtDocumentoOutro"
              name="refTxtDocumentoOutro"
              :tamanho="11"
              validacao="required | text"
              ref="refTxtDocumentoOutro"
              etiqueta="NIS"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="numNis"
            >
            </g-input>
          </div>
          <div
            v-else-if="tipoDocumento === 'PAS'"
            class="col-sm-5 col-xs-5 "
          >
            <g-input
              id="refTxtDocumentoOutro"
              name="refTxtDocumentoOutro"
              :tamanho="10"
              validacao="required | text"
              ref="refTxtDocumentoOutro"
              etiqueta="PASSAPORTE"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="desPassaporte"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div
            v-if="indTipoPessoa !== 'J'"
            class="col-sm-6 col-xs-6"
          >
            <g-input
              id="refNomRequerente"
              name="refNomRequerente"
              ref="refNomRequerente"
              :tamanho="100"
              validacao="required | text"
              etiqueta="Nome"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.nomRequerente"
            >
            </g-input>
          </div>
          <div
            v-else
            class="col-sm-11 col-xs-11 "
          >
            <g-input
              id="refRazaoSocialInput"
              name="refRazaoSocialInput"
              validacao="required | text"
              ref="refRazaoSocialInput"
              etiqueta="Razão Social"
              :tamanho="100"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.nomRequerente"
            >
            </g-input>
          </div>
          <div
            class="col-sm-1 col-xs-1"
            v-if="operacao === 'Editar Requerente'"
          >
            <div v-if="paginaStatus.operacao.descricao === 'Editar Requerente'">
              <q-tooltip>Atualizar requerente de acordo com o cadastro de pessoa do município.</q-tooltip>

              <button
                id="btnPessoa"
                name="btnPessoa"
                class="btn-sync"
                style="margin-top: 15px; margin-left: 5px;"
                @click="buscarPessoa"
              ><i class="fa fa-sync-alt fa-lg"></i>
              </button>
            </div>
          </div>
          <div
            v-if="indTipoPessoa !== 'J'"
            class="col-sm-5 col-xs-5"
          >
            <g-input
              id="refFiliacaoPrincipal"
              name="refFiliacaoPrincipal"
              ref="refFiliacaoPrincipal"
              validacao="text"
              :tamanho="200"
              etiqueta="Filiação Principal"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.desFiliacaoPrimeira"
            >
            </g-input>
          </div>
          <!--
              RN014 - O nome do campo e a máscara exibida no campo deverá ser conforme
              a opção de tipo de pessoa selecionada.
          -->

        </div>
        <div class="row">
          <div
            v-if="indTipoPessoa !== 'J'"
            class="col-sm-2 col-xs-2"
            style="padding-top: 10px;"
          >
            <g-dateInput
              id="refDataNascimentoRequerente"
              name="refDataNascimentoRequerente"
              ref="refDataNascimentoRequerente"
              etiqueta="Data de Nascimento"
              v-model="dataNascimento"
              :desabilitar="paginaStatus.desabilitarEdicao"
              :somenteLeitura="paginaStatus.desabilitarEdicao"
            >
            </g-dateInput>
          </div>
          <div
            v-if="indTipoPessoa !== 'J'"
            class="col-sm-2 col-xs-2"
            style="padding-top: 10px;"
          >
            <g-select
              id="refIndSexo"
              name="refIndSexo"
              ref="refIndSexo"
              etiqueta="Sexo"
              :itens="sexoArray"
              item-valor="indSexo"
              item-etiqueta="descricao"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="indSexo"
            >
            </g-select>
          </div>
          <div
            v-if="indTipoPessoa !== 'J'"
            class="col-sm-2 col-xs-2"
            style="padding-top: 10px;"
          >
            <g-select
              id="refIndEstadoCivil"
              name="refIndEstadoCivil"
              ref="refIndEstadoCivil"
              etiqueta="Estado Civil"
              :itens="estadoCivilArray"
              item-valor="indEstadoCivil"
              item-etiqueta="descricao"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="indEstadoCivil"
            >
            </g-select>
          </div>
          <div
            v-if="indTipoPessoa !== 'J'"
            class="col-sm-3 col-xs-3"
            style="padding-top: 10px;"
          >
            <g-autocomplete
              id="refNacionalidade"
              name="refNacionalidade"
              ref="refNacionalidade"
              etiqueta="Nacionalidade"
              valor="codNacionalidade"
              :foco="false"
              validacao="required | text"
              descricaoPrimaria="nomNacionalidade"
              :api=apiNacionalidade
              v-model="codNacionalidade"
              :desabilitar="paginaStatus.desabilitarEdicao"
            >
            </g-autocomplete>
          </div>
          <div
            class="col-sm-3 col-xs-3"
            style="padding-top: 10px;"
          >
            <g-select
              id="refIndSituacaoCadastral"
              name="refIndSituacaoCadastral"
              ref="refIndSituacaoCadastral"
              etiqueta="Situação Cadastral"
              validacao="required"
              :itens="situacaoCadastralArray"
              item-valor="indSituacaoCadastral"
              item-etiqueta="descricao"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="indSituacaoCadastral"
            >
            </g-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 gvn-title-primary mrg-t-10">Contato</div>
        </div>
        <div class="row">
          <div class="col-sm-2 col-xs-2 ">
            <g-input
              id="refNumTelefoneMovel"
              name="refNumTelefoneMovel"
              ref="refNumTelefoneMovel"
              validacao="Number | telefone"
              etiqueta="Telefone Móvel"
              mascara="telefone"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.numTelefoneMovel"
            >
            </g-input>
          </div>
          <div class="col-sm-2 col-xs-2 ">
            <g-input
              id="refNumTelefoneResidencial"
              name="refNumTelefoneResidencial"
              ref="refNumTelefoneResidencial"
              validacao="text | telefone"
              etiqueta="Telefone Residencial"
              mascara="telefone"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.numTelefoneResidencial"
            >
            </g-input>
          </div>
          <div class="col-sm-2 col-xs-2 ">
            <g-input
              id="refNumTelefoneComercial"
              name="refNumTelefoneComercial"
              ref="refNumTelefoneComercial"
              validacao="text | telefone"
              etiqueta="Telefone Comercial"
              mascara="telefone"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.numTelefoneComercial"
            >
            </g-input>
          </div>
          <div class="col-sm-6 col-xs-6">
            <!-- RN011 - O sistema deverá validar se o e-mail inserido é um e-mail
            válido do formato @mail.com  -->
            <g-input
              id="refTxtEmail"
              name="refTxtEmail"
              ref="refTxtEmail"
              tipo="text"
              etiqueta="E-mail"
              validacao="email"
              :tamanho=100
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.txtEmail"
            >
            </g-input>
          </div>
        </div>
        <!-- RN012 - Ao usuário digitar o CEP,
        o sistema deverá preencher a localização
        (os campos Logradouro, Número, Bairro, Complemento, Cidade e UF)
        de acordo com os dados cadastrados no Sistema de Gestão de Pessoas. -->

        <div class="row">
          <div class="col-12 gvn-title-primary mrg-t-10">Endereço</div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-xs-4">
            <g-input
              id="refNumCep"
              name="refNumCep"
              ref="refNumCep"
              validacao="required | text | cep"
              mascara="cep"
              etiqueta="CEP"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="numCEP"
            >
            </g-input>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
            <div class="mrg-t-20 mrg-l-10">
              <q-icon
                color="blue-grey-9"
                size="1rem"
                name="fas fa-question-circle"
                class="mrg-t-20"
                @click="chamarPaginaCep()"
              >
                <a
                  href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
                  target="_blank"
                  style="text-decoration: none; color: #37474F; margin-left: 10px "
                >Não sei meu CEP
                  <q-tooltip>Clique aqui para buscar o CEP nos correios.</q-tooltip>
                </a>
              </q-icon>
              <div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-6 col-xs-6"
            style="padding-right: 10px;"
          >
            <g-autocomplete
              id="refLogradouro"
              name="refLogradouro"
              ref="refLogradouro"
              etiqueta="Logradouro"
              valor="codLogradouro"
              :foco="false"
              validacao="required | text"
              descricaoPrimaria="nomLogradouro"
              :tamanho="100"
              :api=apiLogradouro
              v-model="paginaStatus.requerente.logradouro.codLogradouro"
              :desabilitar="desabilitarLogradouro "
              permitirTextoLivre="true"
              :filtroAdicional="filtroLogradouro"
            >
            </g-autocomplete>
          </div>
          <div class="col-sm-6 col-xs-6">
            <g-input
              id="refNumero"
              name="refNumero"
              ref="refNumero"
              validacao="Number"
              etiqueta="Número"
              :foco="false"
              :tamanho="5"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.numNumero"
              permitirTextoLivre="true"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-6 col-xs-6"
            style="padding-right: 10px;"
          >
            <g-autocomplete
              id="refBairro"
              name="refBairro"
              ref="refBairro"
              etiqueta="Bairro"
              valor="codBairro"
              :foco="false"
              validacao="required | text"
              descricaoPrimaria="nomBairro"
              :tamanho="100"
              :api=apiBairro
              v-model="paginaStatus.requerente.bairro.codBairro"
              :desabilitar="desabilitarBairro"
              permitirTextoLivre="true"
              :filtroAdicional="filtroLogradouro"
            >
            </g-autocomplete>
          </div>
          <div class="col-sm-6 col-xs-6">
            <g-input
              id="refComplemento"
              name="refComplemento"
              ref="refComplemento"
              validacao="text"
              etiqueta="Complemento"
              :foco="false"
              :tamanho="100"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.requerente.txtComplemento"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-8 col-xs-8"
            style="padding-right: 10px;"
          >
            <g-autocomplete
              id="refCidade"
              name="refCidade"
              ref="refCidade"
              etiqueta="Cidade"
              valor="codMunicipio"
              :foco="false"
              :tamanho="100"
              validacao="required | text"
              descricaoPrimaria="nomMunicipio"
              :api=apiCidade
              v-model="paginaStatus.requerente.municipio.codMunicipio"
              :desabilitar="desabilitarCidade"
              permitirTextoLivre="true"
            >
            </g-autocomplete>
          </div>
          <div class="col-sm-4 col-xs-4">
            <g-select
              id="refUf"
              name="refUf"
              ref="refUf"
              etiqueta="UF"
              validacao="required"
              :itens="ufArray"
              item-valor="codigo"
              item-etiqueta="descricao"
              :foco="false"
              :desabilitar="desabilitarUf"
              v-model="paginaStatus.requerente.uf.codUf"
            >
            </g-select>
          </div>
        </div>
      </q-card-main>
    </q-card>
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        id="btnSalvar"
        name="btnSalvar"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom: 18px"
        class="fixed"
        round
        v-show="!paginaStatus.desabilitarEdicao"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { openURL } from 'quasar'
import GBreadcrumb from 'components/util/gBreadcrumb'
import api from 'components/util/api'
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
import msg from 'components/util/msg'
import GFab from 'components/util/gFab'
import GInput from 'components/util/gInput'
import GDatatable from 'components/util/gDatatable'
import GAutocomplete from 'components/util/gAutocomplete'
import GSelect from 'components/util/gSelect'
import GDatepicker from 'components/util/gDatepicker'
import GDateInput from 'components/util/gDateInput'
import constante from 'components/util/constante'

export default {
  // name: 'requerente',
  // acionaMounted: Function,
  data () {
    return {
      chaveLocalStorage: 'requerente',
      apiRequerente: api.REQUERENTE,
      apiNacionalidade: api.NACIONALIDADE,
      apiLogradouro: api.LOGRADOURO,
      apiCidade: api.CIDADE,
      apiBairro: api.BAIRRO,
      apiUf: api.BUSCAR_LISTA_UF,
      apiPessoaFisica: api.PESSOA_FISICA,
      apiPessoaJuridica: api.PESSOA_JURIDICA,
      apiEndereco: api.BUSCAR_ENDERECOS_PESSOA,
      progresso: false,
      verificarEnderecoNull: false,
      desabilitarCidade: false,
      desabilitarBairro: false,
      desabilitarLogradouro: false,
      desabilitarUf: false,
      modalEditar: false,
      modalEndereco: false,
      nomRequerente: '',
      operacao: '',
      termoEnderecoRequerente: '',
      load: false,
      requerente: {},
      documento: {},
      pessoaFisica: {
        nacionalidade: {},
        pessoa: {}
      },
      pessoaJuridica: {
        pessoa: {}
      },
      tipoPessoaArray: [],
      sexoArray: [],
      documentoArray: [],
      estadoCivilArray: [],
      situacaoCadastralArray: [],
      arrayEndereco: [],
      arrayEndereco2: [],
      ufArray: [],
      indTipoPessoa: '',
      indSexo: '',
      tipoDocumento: '',
      indEstadoCivil: '',
      indSituacaoCadastral: '',
      numCpf: '',
      numCnpj: '',
      numCEP: '',
      numRg: '',
      numNis: '',
      desPassaporte: '',
      codNacionalidade: '',
      dataNascimento: '',
      viaCep: true,
      paginaStatus: {
        desabilitarEdicao: false,
        requerente: {
          nacionalidade: { codNacionalidade: '', nomNacionalidade: '' },
          logradouro: { codLogradouro: '', nomLogradouro: '' },
          bairro: { codBairro: '', nomBairro: '' },
          municipio: { codMunicipio: '', nomMunicipio: '' },
          uf: { codUf: '', nomUf: '' }
        },
        documento: {},
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      }
    }
  },
  methods: {
    limparModalEndereco () {
      this.modalEndereco = false
      this.termoEnderecoRequerente = ''
      this.arrayEndereco2 = []
    },
    formatarDocumento (doc) {
      if (util.validarCampo(doc)) {
        return util.formatarDocumento(doc)
      } else {
        return ''
      }
    },
    mascaraTelefone (num) {
      if (util.validarCampo(num)) {
        return util.mascaraTelefone(num)
      } else {
        return ''
      }
    },
    formatarDiaMesAno (data) {
      if (util.validarCampo(data)) {
        return util.formatarDiaMesAno(data)
      } else {
        return ''
      }
    },
    atualizarEnderecoSelecionado (index) {
      this.arrayEndereco.forEach(item => { item.enderecoSelecionado = 0 })
      let array = util.clonarObjeto(this.arrayEndereco)
      this.arrayEndereco = []
      array[index].enderecoSelecionado = array[index].codPessoaEndereco
      this.arrayEndereco = array
    },
    atualizarEnderecoSelecionado2 (index) {
      this.arrayEndereco2.forEach(item => { item.enderecoSelecionado = 0 })
      let array = util.clonarObjeto(!this.termoEnderecoRequerente ? this.arrayEndereco2 : this.arrayEndereco2.filter(x => x.logradouro.trim().toUpperCase().includes(this.termoEnderecoRequerente.trim().toUpperCase()) || (x.nomBairro || x.bairro).trim().toUpperCase().includes(this.termoEnderecoRequerente.trim().toUpperCase())))
      this.arrayEndereco2 = []
      array[index].enderecoSelecionado = array[index].codLocalizacao
      this.arrayEndereco2 = array
    },
    filtroLogradouro () {
      let filtro = ''
      if (this.paginaStatus.requerente.municipio.nomMunicipio && this.numCEP.length < 10) filtro += '?nomMunicipio=' + this.paginaStatus.requerente.municipio.nomMunicipio
      return filtro
    },
    verificarLogradouro (item) {
      var self = this
      self.arrayEndereco2 = []
      let url = api.BUSCAR_TODAS_LOCALIZACOES_PELO_LOGRADOURO + '?nomLogradouro=' + item.label.toString().trim()
      utilHttp.httpGet(url, resposta => {
        // Se existir dados já cadastrados no sistema de gestão de pessoas
        if (resposta.body.length > 0) {
          self.termoEnderecoRequerente = ''
          let array = util.clonarObjeto(resposta.body)
          array.forEach(item => {
            item.cep = item.codCep
            item.tipoLogradouro = item.bairroLogradouro.logradouro.tipoLogradouro.nomTipoLogradouro
            item.logradouro = item.bairroLogradouro.logradouro.nomLogradouro
            item.nomBairro = item.bairroLogradouro.bairro.nomBairro
            item.bairro = item.bairroLogradouro.bairro
            item.localidadeUf = item.bairroLogradouro.bairro.municipio.nomMunicipioUf
            let obj = {
              bairro: item.bairroLogradouro.bairro.nomBairro,
              cep: item.codCep,
              cepMultiplosLogradouros: null,
              codBairro: item.bairroLogradouro.bairro.codBairro,
              codBairroLograoudo: item.bairroLogradouro.codBairroLogradouro,
              codLocalidade: item.bairroLogradouro.logradouro.municipio.codMunicipio,
              codLocalizacao: item.codLocalizacao,
              codLogradouro: item.bairroLogradouro.logradouro.codLogradouro,
              codMunicipio: item.bairroLogradouro.logradouro.municipio.codMunicipio,
              codTipoLogradouro: item.bairroLogradouro.logradouro.tipoLogradouro.codTipoLogradouro,
              codUf: item.bairroLogradouro.logradouro.municipio.uf.codUf,
              complemento: null,
              ibge: item.bairroLogradouro.logradouro.municipio.uf.codUfIbge,
              localidade: item.bairroLogradouro.logradouro.municipio.nomMunicipio,
              localidadeUf: item.bairroLogradouro.logradouro.municipio.nomMunicipioUf,
              logradouro: item.bairroLogradouro.logradouro.nomLogradouro,
              nomBairro: item.bairroLogradouro.bairro.nomBairro,
              nomMunicipio: item.bairroLogradouro.logradouro.municipio.nomMunicipio,
              tipoLogradouro: item.bairroLogradouro.logradouro.tipoLogradouro.nomTipoLogradouro,
              tipoLogradouroSigla: item.bairroLogradouro.logradouro.tipoLogradouro.sglTipoLogradouro,
              uf: item.bairroLogradouro.logradouro.municipio.uf.sglUf,
              ufNome: item.bairroLogradouro.logradouro.municipio.uf.nomUf
            }
            self.arrayEndereco2.push(obj)
          })

          if (resposta.body.length === 1) {
            self.atualizarEnderecoSelecionado2(0)
            setTimeout(() => {
              self.atualizarEnderecoRequerente()
            }, 100)
          } else {
            self.modalEndereco = true
          }
        }
      })
    },
    salvar () {
      var self = this
      iniciar()
      async function iniciar () {
        if (self.dataNascimento) {
          self.paginaStatus.requerente.dataNascimento = new Date(util.formatarAnoMesDia(self.dataNascimento, 'DD/MM/YYYY'))
        }
        if (self.paginaStatus.requerente.dataNascimento > new Date()) {
          util.exibirToastFalha('Favor verificar a data informada')
        } else {
          self.requerente = util.clonarObjeto(self.paginaStatus.requerente)
          self.requerente.numCEP = util.clonarObjeto(self.numCEP)
          if (util.validarComponentes(self.$refs)) {
            if (await self.setNomeEDocumento() && await self.setIndicadores() && await self.removerMascaras()) {
              // Set Usuário
              self.requerente.codUsuario = self.$login.getCodUsuario()
              setTimeout(() => {
                if (self.paginaStatus.operacao.descricao === 'Editar Requerente') {
                  if (!self.requerente.bairro.codBairro && self.$refs['refBairro'].termo) {
                    self.requerente.bairro = { codBairro: null, nomBairro: self.$refs['refBairro'].termo }
                  } else {
                    if (self.paginaStatus.requerente.bairro.codBairro && self.$refs['refBairro'].termo) {
                      self.paginaStatus.requerente.bairro.nomBairro = self.$refs['refBairro'].termo
                      self.requerente.bairro.nomBairro = self.$refs['refBairro'].termo
                    }
                  }
                  if (!self.requerente.logradouro.codLogradouro && self.$refs['refLogradouro'].termo) {
                    self.requerente.logradouro = { codLogradouro: null, nomLogradouro: self.$refs['refLogradouro'].termo }
                  } else {
                    if (self.paginaStatus.requerente.logradouro.codLogradouro && self.$refs['refLogradouro'].termo) {
                      self.paginaStatus.requerente.logradouro.nomLogradouro = self.$refs['refLogradouro'].termo
                      self.requerente.logradouro.nomLogradouro = self.$refs['refLogradouro'].termo
                    }
                  }
                  utilHttp.httpPutCarregando(self.apiRequerente.concat('/').concat(self.requerente.codRequerente), self.requerente, resposta => {
                    util.exibirToastSucesso(msg.m(3))
                    util.retornarCaminhoMigalhaPaginaAnterior(self)
                  })
                } else if (self.paginaStatus.operacao.descricao === 'Novo') {
                  if (!self.paginaStatus.requerente.bairro.codBairro && self.$refs['refBairro'].termo) {
                    self.requerente.bairro = { codBairro: null, nomBairro: self.$refs['refBairro'].termo }
                  }
                  if (!self.paginaStatus.requerente.logradouro.codLogradouro && self.$refs['refLogradouro'].termo) {
                    self.requerente.logradouro = { codLogradouro: null, nomLogradouro: self.$refs['refLogradouro'].termo }
                  }
                  utilHttp.httpPostCarregando(self.apiRequerente, self.requerente, resposta => {
                    util.exibirToastSucesso(msg.m(2))
                    if (!self.paginaStatus.modal) {
                      util.retornarCaminhoMigalhaPaginaAnterior(self)
                    } else {
                      // self.$refs.refModal.hide()
                    }
                  })
                }
              }, 200)
            }
          }
        }
      }
    },
    dataAtual () {
      let dNow = new Date()
      return util.criarData(dNow)
    },
    async setNomeEDocumento () {
      var self = this
      return new Promise(resolve => {
        // Ao Salvar, preenche o campo txtDocumento de acordo com o tipo de pessoa selecionada
        self.requerente.nomRequerente = self.paginaStatus.requerente.nomRequerente
        if (self.indTipoPessoa === 'F') {
          // Set Documento
          self.requerente.txtDocumento = self.numCpf
        } else if (self.indTipoPessoa === 'J') {
          self.requerente.txtDocumento = self.numCnpj
          // Set Nome Usuário pessoa Jurídica
          // if (self.paginaStatus.operacao.descricao === 'Novo') {
          //   var pj = self.$refs['refRazaoSocial']
          //   if (pj.objetoSelecionado.desRazaoSocial === undefined || pj.objetoSelecionado.desRazaoSocialNumCnpj !== pj.$refs.inputText.value) {
          //     self.requerente.nomRequerente = pj.$refs.inputText.value
          //   } else {
          //     self.requerente.nomRequerente = pj.objetoSelecionado.desRazaoSocial
          //   }
          // }
        } else {
          if (self.tipoDocumento === 'RG') {
            self.requerente.txtDocumento = self.numRg
          } else if (self.tipoDocumento === 'PAS') {
            self.requerente.txtDocumento = self.desPassaporte
          } else if (self.tipoDocumento === 'NIS') {
            self.requerente.txtDocumento = self.numNis
          }
        }
        // Set Nome Usuário pessoa física
        // if (self.indTipoPessoa !== 'J') {
        //   if (self.paginaStatus.operacao.descricao === 'Novo') {
        //     var pf = self.$refs['refNomRequerente']
        //     if (pf.objetoSelecionado.nomPessoa === undefined || pf.objetoSelecionado.nomeDataNascimentoCpf !== pf.$refs.inputText.value) {
        //       self.requerente.nomRequerente = pf.$refs.inputText.value
        //     } else {
        //       self.requerente.nomRequerente = pf.objetoSelecionado.nomPessoa
        //     }
        //   }
        // }
        return resolve(true)
      })
    },
    async setIndicadores () {
      var self = this
      return new Promise(resolve => {
        // Ao Salvar, preenche o objeto de acordo com os indicadores selecionados.
        if (self.indTipoPessoa !== 'J') {
          self.requerente.indSexo = self.indSexo
          self.requerente.indEstadoCivil = self.indEstadoCivil
          self.requerente.nacionalidade.codNacionalidade = self.codNacionalidade
          if (self.indTipoPessoa === 'O') {
            self.requerente.indTipoDocumento = self.tipoDocumento
          } else {
            self.requerente.indTipoDocumento = 'CPF'
          }
        } else {
          self.requerente.indSexo = null
          self.requerente.indEstadoCivil = null
          self.requerente.dataNascimento = null
          self.requerente.indTipoDocumento = 'CNP'
          self.requerente.nacionalidade.codNacionalidade = 10
        }
        self.requerente.indSituacaoCadastral = self.indSituacaoCadastral
        self.requerente.indTipoPessoa = self.indTipoPessoa
        return resolve(true)
      })
    },
    async removerMascaras () {
      var self = this
      return new Promise(resolve => {
        // Por padrão, os dados são salvos no banco sem formatação
        if (self.requerente.numCEP !== null && self.requerente.numCEP !== '' && self.requerente.numCEP !== undefined) {
          self.requerente.numCEP = util.removerFormatacao(self.requerente.numCEP.toString())
        }
        if (self.requerente.numTelefoneMovel !== null && self.requerente.numTelefoneMovel !== '' && self.requerente.numTelefoneMovel !== undefined) {
          self.requerente.numTelefoneMovel = util.removerFormatacao(self.requerente.numTelefoneMovel.toString())
        }
        if (self.requerente.numTelefoneResidencial !== null && self.requerente.numTelefoneResidencial !== '' && self.requerente.numTelefoneResidencial !== undefined) {
          self.requerente.numTelefoneResidencial = util.removerFormatacao(self.requerente.numTelefoneResidencial.toString())
        }
        if (self.requerente.numTelefoneComercial !== null && self.requerente.numTelefoneComercial !== '' && self.requerente.numTelefoneComercial !== undefined) {
          self.requerente.numTelefoneComercial = util.removerFormatacao(self.requerente.numTelefoneComercial.toString())
        }
        // No documento só tem máscara no CPF e CNPJ, ou seja, ao selecionar pessoa Física ou Jurídica
        if (self.indTipoPessoa !== 'O') {
          if (self.requerente.txtDocumento !== null && self.requerente.txtDocumento !== '' && self.requerente.txtDocumento !== undefined) {
            self.requerente.txtDocumento = util.limparFormatacaoDocumento(self.requerente.txtDocumento.toString(), constante.TIPO_LIMPEZA_DUCUMENTO[self.indTipoPessoa === 'J' ? 'CNPJ' : 'CPF'])
            util.removerFormatacao(self.requerente.txtDocumento.toString())
          }
        }
        return resolve(true)
      })
    },
    carregarSelects () {
      // Monta os vetores dos g-selects de acordo com as regras de negócio:
      // RN006, RN007, RN008, RN009, RN010, RN016
      var self = this
      utilHttp.httpGet(self.apiUf, resposta => {
        var listaUfs = []
        listaUfs = resposta.body
        listaUfs.forEach(uf => {
          self.ufArray.push({
            codigo: uf.codUf,
            descricao: uf.nomUf
          })
        })
      })

      self.tipoPessoaArray = [
        { indTipoPessoa: 'F', descricao: 'Física' },
        { indTipoPessoa: 'J', descricao: 'Jurídica' },
        { indTipoPessoa: 'O', descricao: 'Outro' }
      ]
      self.sexoArray = [
        { indSexo: 'M', descricao: 'Masculino' },
        { indSexo: 'F', descricao: 'Feminino' },
        { indSexo: 'I', descricao: 'Indiferente' }
      ]
      self.estadoCivilArray = [
        { indEstadoCivil: 'S', descricao: 'Solteiro' },
        { indEstadoCivil: 'C', descricao: 'Casado' },
        { indEstadoCivil: 'D', descricao: 'Divorciado' },
        { indEstadoCivil: 'V', descricao: 'Viúvo' },
        { indEstadoCivil: 'A', descricao: 'Amasiado' },
        { indEstadoCivil: 'Q', descricao: 'Desquitado' },
        { indEstadoCivil: 'O', descricao: 'Outros' }
      ]
      self.situacaoCadastralArray = [
        { indSituacaoCadastral: 'A', descricao: 'Ativo' },
        { indSituacaoCadastral: 'I', descricao: 'Inativo' },
        { indSituacaoCadastral: 'B', descricao: 'Baixado' },
        { indSituacaoCadastral: 'S', descricao: 'Suspenso' }
        // { indsituacaoCadastral: 'N', descricao: 'Inativo' },
        // { indsituacaoCadastral: 'S', descricao: 'Ativo' }
      ]
      self.documentoArray = [
        { tipoDocumento: 'RG', descricao: 'RG' },
        { tipoDocumento: 'NIS', descricao: 'NIS' },
        { tipoDocumento: 'PAS', descricao: 'PASSAPORTE' }
      ]
    },
    carregarAutoCompletes () {
      var self = this

      // NOME DO REQUERENTE
      if (self.indTipoPessoa === 'F' || self.indTipoPessoa === 'O') {
        // if (self.$refs['refNomRequerente'] !== undefined && self.$refs['refNomRequerente'] !== null) {
        //   self.$refs['refNomRequerente'].carregar(self.paginaStatus.requerente.codRequerente, self.paginaStatus.requerente.nomeDataNascimentoCpf)
        // }

        self.$refs['refNacionalidade'].carregar(self.paginaStatus.requerente.nacionalidade.codNacionalidade, self.paginaStatus.requerente.nacionalidade.nomNacionalidade)
      }
      // else if (self.indTipoPessoa === 'J') {
      //   if (self.$refs['refRazaoSocial'] !== undefined && self.$refs['refRazaoSocial'] !== null) {
      //     self.$refs['refRazaoSocial'].carregar(self.paginaStatus.requerente.codRequerente, self.paginaStatus.requerente.nomeDataNascimentoCpf)
      //   }
      // }
    },
    mascarasToString () {
      var self = this
      // O sistema salva no banco os dados sem a formatação da máscara, então, é necessário converter
      // os campos para String para utilizar algumas funções, como por exemplo o replace(),
      // que é uma função do tipo String.
      if (self.paginaStatus.requerente.numCEP !== null && self.paginaStatus.requerente.numCEP !== '' && self.paginaStatus.requerente.numCEP !== undefined) {
        self.paginaStatus.requerente.numCEP = self.paginaStatus.requerente.numCEP.toString()
      }
      if (self.paginaStatus.requerente.numTelefoneMovel !== null && self.paginaStatus.requerente.numTelefoneMovel !== '' && self.paginaStatus.requerente.numTelefoneMovel !== undefined) {
        self.paginaStatus.requerente.numTelefoneMovel = self.paginaStatus.requerente.numTelefoneMovel.toString()
      }
      if (self.paginaStatus.requerente.numTelefoneResidencial !== null && self.paginaStatus.requerente.numTelefoneResidencial !== '' && self.paginaStatus.requerente.numTelefoneResidencial !== undefined) {
        self.paginaStatus.requerente.numTelefoneResidencial = self.paginaStatus.requerente.numTelefoneResidencial.toString()
      }
      if (self.paginaStatus.requerente.numTelefoneComercial !== null && self.paginaStatus.requerente.numTelefoneComercial !== '' && self.paginaStatus.requerente.numTelefoneComercial !== undefined) {
        self.paginaStatus.requerente.numTelefoneComercial = self.paginaStatus.requerente.numTelefoneComercial.toString()
      }
      // this.paginaStatus.requerente.txtDocumento = this.paginaStatus.requerente.txtDocumento.toString()
    },
    atualizarCampos () {
      var self = this
      // cpf, cnpj, rg, nis e passaporte são valores que estão fora do paginaStatus, então,
      // é preciso adicionar um valor a estas dates, de acordo com indTipoPessoa
      self.mascarasToString()
      self.carregarAutoCompletes()

      if (self.indTipoPessoa === 'F') {
        setTimeout(() => {
          self.numCpf = self.paginaStatus.requerente.txtDocumento
        }, 100)
      } else if (self.indTipoPessoa === 'J') {
        setTimeout(() => {
          self.numCnpj = self.paginaStatus.requerente.txtDocumento
        }, 100)
      } else {
        if (self.tipoDocumento === 'RG') {
          setTimeout(() => {
            self.numRg = self.paginaStatus.requerente.txtDocumento
          }, 100)
        } else if (self.tipoDocumento === 'NIS') {
          setTimeout(() => {
            self.numNis = self.paginaStatus.requerente.txtDocumento
          }, 100)
        } else if (self.tipoDocumento === 'PAS') {
          setTimeout(() => {
            self.desPassaporte = self.paginaStatus.requerente.txtDocumento
          }, 100)
        }
      }
      setTimeout(() => {
        if (self.paginaStatus.requerente.numCEP) {
          self.numCEP = self.paginaStatus.requerente.numCEP
        }
      }, 100)
      setTimeout(() => {
        // SET LOGRADOURO
        self.$refs['refLogradouro'].carregar(self.paginaStatus.requerente.logradouro.codLogradouro, self.paginaStatus.requerente.logradouro.nomLogradouro)
      }, 500)
      setTimeout(() => {
        // SET BAIRRO
        self.$refs['refBairro'].carregar(self.paginaStatus.requerente.bairro.codBairro, self.paginaStatus.requerente.bairro.nomBairro)
      }, 500)
      setTimeout(() => {
        // SET CIDADE
        self.$refs['refCidade'].carregar(self.paginaStatus.requerente.municipio.codMunicipio, self.paginaStatus.requerente.municipio.nomMunicipio)
      }, 500)
    },
    setIndSituacaoCadastral (indicador) {
      if (indicador === 'S') {
        return 'A'
      } else {
        return 'I'
      }
    },
    setNomNacionalidade (codNacionalidade) {
      let url = this.apiNacionalidade.concat('/').concat(codNacionalidade)
      utilHttp.httpGet(url, resposta => {
        return resposta.body.nomNacionalidade.toString()
      })
    },
    setNomUf (sigla) {
      switch (sigla) {
        case 'AC': return 'ACRE'
        case 'AL': return 'ALAGOAS'
        case 'AP': return 'AMAPÁ'
        case 'AM': return 'AMAZONAS'
        case 'BA': return 'BAHIA'
        case 'CE': return 'CEARÁ'
        case 'DF': return 'DISTRITO FEDERAL'
        case 'ES': return 'ESPÍRITO SANTO'
        case 'RR': return 'RORAIMA'
        case 'GO': return 'GOIÁS'
        case 'MA': return 'MARANHÃO'
        case 'MT': return 'MATO GROSSO'
        case 'MS': return 'MATO GROSSO DO SUL'
        case 'MG': return 'MINAS GERAIS'
        case 'PA': return 'PARÁ'
        case 'PB': return 'PARAÍBA'
        case 'PR': return 'PARANÁ'
        case 'PE': return 'PERNAMBUCO'
        case 'PI': return 'PIAUÍ'
        case 'RJ': return 'RIO DE JANEIRO'
        case 'RN': return 'RIO GRANDE DO NORTE'
        case 'RS': return 'RIO GRANDE DO SUL'
        case 'RO': return 'RONDÔNIA'
        case 'TO': return 'TOCANTINS'
        case 'SC': return 'SANTA CATARINA'
        case 'SP': return 'SÃO PAULO'
        case 'SE': return 'SERGIPE'
      }
    },
    verificarSeExisteInformacao (campo, pessoaFisicaJuridica) {
      var self = this
      // Caso tenha uma informação do requerente que não exista no cadastro de pessoas, mantém.
      if (campo === 'txtEmail') {
        if (pessoaFisicaJuridica.pessoa !== undefined && pessoaFisicaJuridica.pessoa.desEmail !== null &&
          pessoaFisicaJuridica.pessoa.desEmail !== '' &&
          pessoaFisicaJuridica.pessoa.desEmail !== undefined) {
          return pessoaFisicaJuridica.pessoa.desEmail.toString()
        } else if (self.paginaStatus.requerente.txtEmail !== null &&
          self.paginaStatus.requerente.txtEmail !== '' &&
          self.paginaStatus.requerente.txtEmail !== undefined) {
          return self.paginaStatus.requerente.txtEmail.toString()
        } else return ''
      }

      if (campo === 'numTelefoneMovel') {
        if (pessoaFisicaJuridica.pessoa !== undefined && pessoaFisicaJuridica.pessoa.numTelefone1 !== null &&
          pessoaFisicaJuridica.pessoa.numTelefone1 !== '' &&
          pessoaFisicaJuridica.pessoa.numTelefone1 !== undefined) {
          return pessoaFisicaJuridica.pessoa.numTelefone1.toString()
        } else if (self.paginaStatus.requerente.numTelefoneMovel !== null &&
          self.paginaStatus.requerente.numTelefoneMovel !== '' &&
          self.paginaStatus.requerente.numTelefoneMovel !== undefined) {
          return self.paginaStatus.requerente.numTelefoneMovel.toString()
        } else return ''
      }

      if (campo === 'numTelefoneResidencial') {
        if (pessoaFisicaJuridica.pessoa !== undefined && pessoaFisicaJuridica.pessoa.numTelefone2 !== null &&
          pessoaFisicaJuridica.pessoa.numTelefone2 !== '' &&
          pessoaFisicaJuridica.pessoa.numTelefone2 !== undefined) {
          return pessoaFisicaJuridica.pessoa.numTelefone2.toString()
        } else if (self.paginaStatus.requerente.numTelefoneResidencial !== null &&
          self.paginaStatus.requerente.numTelefoneResidencial !== '' &&
          self.paginaStatus.requerente.numTelefoneResidencial !== undefined) {
          return self.paginaStatus.requerente.numTelefoneResidencial.toString()
        } else return ''
      }

      if (campo === 'numTelefoneComercial') {
        if (pessoaFisicaJuridica.pessoa !== undefined && pessoaFisicaJuridica.pessoa.numTelefone3 !== null &&
          pessoaFisicaJuridica.pessoa.numTelefone3 !== '' &&
          pessoaFisicaJuridica.pessoa.numTelefone3 !== undefined) {
          return pessoaFisicaJuridica.pessoa.numTelefone3.toString()
        } else if (self.paginaStatus.requerente.numTelefoneComercial !== null &&
          self.paginaStatus.requerente.numTelefoneComercial !== '' &&
          self.paginaStatus.requerente.numTelefoneComercial !== undefined) {
          return self.paginaStatus.requerente.numTelefoneComercial.toString()
        } else return ''
      }

      if (campo === 'codNacionalidade') {
        if (pessoaFisicaJuridica.nacionalidade !== undefined && pessoaFisicaJuridica.nacionalidade.codNacionalidade !== null &&
          pessoaFisicaJuridica.nacionalidade.codNacionalidade !== '' &&
          pessoaFisicaJuridica.nacionalidade.codNacionalidade !== undefined) {
          return pessoaFisicaJuridica.nacionalidade.codNacionalidade
        } else if (self.codNacionalidade !== null &&
          self.codNacionalidade !== '' &&
          self.codNacionalidade !== undefined) {
          return self.codNacionalidade
        } else return ''
      }

      if (campo === 'nomNacionalidade') {
        if (pessoaFisicaJuridica.nacionalidade !== undefined && pessoaFisicaJuridica.nacionalidade.nomNacionalidade !== null &&
          pessoaFisicaJuridica.nacionalidade.nomNacionalidade !== '' &&
          pessoaFisicaJuridica.nacionalidade.nomNacionalidade !== undefined) {
          return pessoaFisicaJuridica.nacionalidade.nomNacionalidade.toString()
        } else if (self.paginaStatus.requerente.nacionalidade.nomNacionalidade !== null &&
          self.paginaStatus.requerente.nacionalidade.nomNacionalidade !== '' &&
          self.paginaStatus.requerente.nacionalidade.nomNacionalidade !== undefined) {
          return self.paginaStatus.requerente.nacionalidade.nomNacionalidade.toString()
        } else return ''
      }

      if (campo === 'numNumero') {
        if (pessoaFisicaJuridica.pessoaEndereco !== undefined && pessoaFisicaJuridica.pessoaEndereco.numEndereco !== null &&
          pessoaFisicaJuridica.pessoaEndereco.numEndereco !== '' &&
          pessoaFisicaJuridica.pessoaEndereco.numEndereco !== undefined) {
          return pessoaFisicaJuridica.pessoaEndereco.numEndereco
        } else if (self.paginaStatus.requerente.numNumero !== null &&
          self.paginaStatus.requerente.numNumero !== '' &&
          self.paginaStatus.requerente.numNumero !== undefined) {
          return self.paginaStatus.requerente.numNumero
        } else return ''
      }

      if (campo === 'txtComplemento') {
        if (pessoaFisicaJuridica.pessoaEndereco !== undefined && pessoaFisicaJuridica.pessoaEndereco.desComplemento !== null &&
          pessoaFisicaJuridica.pessoaEndereco.desComplemento !== '' &&
          pessoaFisicaJuridica.pessoaEndereco.desComplemento !== undefined) {
          return pessoaFisicaJuridica.pessoaEndereco.desComplemento.toString()
        } else if (self.paginaStatus.requerente.txtComplemento !== null &&
          self.paginaStatus.requerente.txtComplemento !== '' &&
          self.paginaStatus.requerente.txtComplemento !== undefined) {
          return self.paginaStatus.requerente.txtComplemento.toString()
        } else return ''
      }

      if (campo === 'numCEP') {
        if (pessoaFisicaJuridica.pessoaEndereco !== undefined && pessoaFisicaJuridica.pessoaEndereco.codCepEndFraco !== null &&
          pessoaFisicaJuridica.pessoaEndereco.codCepEndFraco !== '' &&
          pessoaFisicaJuridica.pessoaEndereco.codCepEndFraco !== undefined) {
          return pessoaFisicaJuridica.pessoaEndereco.codCepEndFraco
        } else if (self.paginaStatus.requerente.numCEP !== null &&
          self.paginaStatus.requerente.numCEP !== '' &&
          self.paginaStatus.requerente.numCEP !== undefined) {
          return self.paginaStatus.requerente.numCEP
        } else return ''
      }
      if (campo === 'codLogradouro') {
        if (pessoaFisicaJuridica.pessoaEndereco !== undefined && pessoaFisicaJuridica.pessoaEndereco.codPessoaEndereco !== null &&
          pessoaFisicaJuridica.pessoaEndereco.codPessoaEndereco !== '' &&
          pessoaFisicaJuridica.pessoaEndereco.codPessoaEndereco !== undefined) {
          return pessoaFisicaJuridica.pessoaEndereco.codPessoaEndereco
        } else if (self.paginaStatus.requerente.logradouro.codLogradouro !== null &&
          self.paginaStatus.requerente.logradouro.codLogradouro !== '' &&
          self.paginaStatus.requerente.logradouro.codLogradouro !== undefined) {
          return self.paginaStatus.requerente.logradouro.codLogradouro
        } else return ''
      }

      if (campo === 'nomLogradouro') {
        if (pessoaFisicaJuridica.pessoaEndereco !== undefined && pessoaFisicaJuridica.pessoaEndereco.nomLogradouroEndFraco !== null &&
          pessoaFisicaJuridica.pessoaEndereco.nomLogradouroEndFraco !== '' &&
          pessoaFisicaJuridica.pessoaEndereco.nomLogradouroEndFraco !== undefined) {
          return pessoaFisicaJuridica.pessoaEndereco.nomLogradouroEndFraco.toString()
        } else if (self.paginaStatus.requerente.logradouro.nomLogradouro !== null &&
          self.paginaStatus.requerente.logradouro.nomLogradouro !== '' &&
          self.paginaStatus.requerente.logradouro.nomLogradouro !== undefined) {
          return self.paginaStatus.requerente.logradouro.nomLogradouro.toString()
        } else return ''
      }

      if (campo === 'codBairro') {
        if (pessoaFisicaJuridica.pessoaEndereco !== undefined && pessoaFisicaJuridica.pessoaEndereco.codBairroEndFraco !== null &&
          pessoaFisicaJuridica.pessoaEndereco.codBairroEndFraco !== '' &&
          pessoaFisicaJuridica.pessoaEndereco.codBairroEndFraco !== undefined) {
          return pessoaFisicaJuridica.pessoaEndereco.codBairroEndFraco
        } else if (self.paginaStatus.requerente.bairro.codBairro !== null &&
          self.paginaStatus.requerente.bairro.codBairro !== '' &&
          self.paginaStatus.requerente.bairro.codBairro !== undefined) {
          return self.paginaStatus.requerente.bairro.codBairro
        } else return ''
      }

      if (campo === 'nomBairro') {
        if (self.paginaStatus.requerente.bairro.nomBairro !== null &&
          self.paginaStatus.requerente.bairro.nomBairro !== '' &&
          self.paginaStatus.requerente.bairro.nomBairro !== undefined) {
          return self.paginaStatus.requerente.bairro.nomBairro.toString()
        } else return ''
      }

      if (campo === 'codMunicipio') {
        if (self.paginaStatus.requerente.municipio.codMunicipio !== null &&
          self.paginaStatus.requerente.municipio.codMunicipio !== '' &&
          self.paginaStatus.requerente.municipio.codMunicipio !== undefined) {
          return self.paginaStatus.requerente.municipio.codMunicipio
        } else return ''
      }

      if (campo === 'nomMunicipio') {
        if (self.paginaStatus.requerente.municipio.nomMunicipio !== null &&
          self.paginaStatus.requerente.municipio.nomMunicipio !== '' &&
          self.paginaStatus.requerente.municipio.nomMunicipio !== undefined) {
          return self.paginaStatus.requerente.municipio.nomMunicipio.toString()
        } else return ''
      }

      if (campo === 'codUf') {
        if (self.paginaStatus.requerente.uf.codUf !== null &&
          self.paginaStatus.requerente.uf.codUf !== '' &&
          self.paginaStatus.requerente.uf.codUf !== undefined) {
          return self.paginaStatus.requerente.uf.codUf
        } else return ''
      }

      if (campo === 'nomUf') {
        if (self.paginaStatus.requerente.uf.nomUf !== null &&
          self.paginaStatus.requerente.uf.nomUf !== '' &&
          self.paginaStatus.requerente.uf.nomUf !== undefined) {
          return self.paginaStatus.requerente.uf.nomUf
        } else return ''
      }
    },
    desabilitarEnderecos () {
      var self = this
      var nomLogradouro = self.paginaStatus.requerente.logradouro.nomLogradouro
      var nomBairro = self.paginaStatus.requerente.bairro.nomBairro
      var nomMunicipio = self.paginaStatus.requerente.municipio.nomMunicipio
      var nomUf = self.paginaStatus.requerente.uf.codUf

      // Vai desabilitar somente no "NOVO"
      if (self.paginaStatus.operacao.descricao === 'Novo') {
        if (nomLogradouro !== null & nomLogradouro !== '' & nomLogradouro !== null) {
          self.desabilitarLogradouro = false
        } else self.desabilitarLogradouro = false
        if (nomBairro !== null & nomBairro !== '' & nomBairro !== null) {
          self.desabilitarBairro = false
        } else self.desabilitarBairro = false
        if (nomMunicipio !== null & nomMunicipio !== '' & nomMunicipio !== null) {
          self.desabilitarCidade = true
        } else self.desabilitarCidade = false
        if (nomUf !== null & nomUf !== '' & nomUf !== null) {
          self.desabilitarUf = true
        } else self.desabilitarUf = false
      } else if (self.paginaStatus.operacao.descricao === 'Visualizar') {
        self.desabilitarLogradouro = true
        self.desabilitarBairro = true
        self.desabilitarCidade = true
        self.desabilitarUf = true
      }
    },
    preencherPessoaFisica (pessoaFisica) {
      var self = this
      self.requerente = {
        nomRequerente: pessoaFisica.nomPessoa,
        indSexo: pessoaFisica.indSexo !== undefined ? pessoaFisica.indSexo : self.paginaStatus.requerente.indSexo,
        indEstadoCivil: !util.validarCampo(pessoaFisica.indEstadoCivilDescricao) ? self.requerente.indEstadoCivil : self.estadoCivilArray.filter(item => item.descricao.trim().toUpperCase() === pessoaFisica.indEstadoCivilDescricao.trim().toUpperCase())[0].indEstadoCivil.trim().toUpperCase(),
        indSituacaoCadastral: 'A',
        desFiliacaoPrimeira: pessoaFisica.desFiliacaoPrimeira,
        indTipoPessoa: self.indTipoPessoa,
        txtEmail: self.verificarSeExisteInformacao('txtEmail', pessoaFisica),
        numTelefoneMovel: self.verificarSeExisteInformacao('numTelefoneMovel', pessoaFisica),
        numTelefoneResidencial: self.verificarSeExisteInformacao('numTelefoneResidencial', pessoaFisica),
        numTelefoneComercial: self.verificarSeExisteInformacao('numTelefoneComercial', pessoaFisica),
        numNumero: self.verificarSeExisteInformacao('numNumero', pessoaFisica),
        txtComplemento: self.verificarSeExisteInformacao('txtComplemento', pessoaFisica),
        nacionalidade: {
          codNacionalidade: self.verificarSeExisteInformacao('codNacionalidade', pessoaFisica),
          nomNacionalidade: self.verificarSeExisteInformacao('nomNacionalidade', pessoaFisica)
        },
        logradouro: {
          codLogradouro: self.verificarSeExisteInformacao('codLogradouro', pessoaFisica),
          nomLogradouro: self.verificarSeExisteInformacao('nomLogradouro', pessoaFisica)
        },
        bairro: {
          codBairro: self.verificarSeExisteInformacao('codBairro', pessoaFisica),
          nomBairro: self.verificarSeExisteInformacao('nomBairro', pessoaFisica)
        },
        municipio: {
          codMunicipio: self.verificarSeExisteInformacao('codMunicipio', pessoaFisica),
          nomMunicipio: self.verificarSeExisteInformacao('nomMunicipio', pessoaFisica)
        },
        uf: {
          codUf: self.verificarSeExisteInformacao('codUf', pessoaFisica),
          nomUf: self.verificarSeExisteInformacao('nomUf', pessoaFisica)
        }
      }
      // Se for pessoa Física mas foi selecionado "outro"
      if (self.requerente.indTipoPessoa === 'O') {
        if (pessoaFisica.numRg !== undefined && pessoaFisica.numRg !== null && pessoaFisica.numRg !== '') {
          self.requerente.indTipoDocumento = 'RG'
          self.requerente.txtDocumento = pessoaFisica.numRg
        } else if (pessoaFisica.numNis !== undefined && pessoaFisica.numNis !== null && pessoaFisica.numNis !== '') {
          self.requerente.indTipoDocumento = 'NIS'
          self.requerente.txtDocumento = pessoaFisica.numNis
        } else if (pessoaFisica.desPassaporte !== undefined && pessoaFisica.desPassaporte !== null && pessoaFisica.desPassaporte !== '') {
          self.requerente.indTipoDocumento = 'PAS'
          self.requerente.txtDocumento = pessoaFisica.desPassaporte
        }
      } else {
        self.requerente.indTipoDocumento = 'CPF'
        if (pessoaFisica.numCpf !== undefined && pessoaFisica.numCpf !== null && pessoaFisica.numCpf !== '') {
          self.requerente.txtDocumento = pessoaFisica.numCpf
        }
      }
      self.indSexo = pessoaFisica.indSexo !== undefined ? pessoaFisica.indSexo : self.paginaStatus.requerente.indSexo
      self.indEstadoCivil = !util.validarCampo(pessoaFisica.indEstadoCivilDescricao) ? self.requerente.indEstadoCivil : self.estadoCivilArray.filter(item => item.descricao.trim().toUpperCase() === pessoaFisica.indEstadoCivilDescricao.trim().toUpperCase())[0].indEstadoCivil.trim().toUpperCase()

      if (self.operacao === 'Editar Requerente') {
        self.requerente.codRequerente = self.paginaStatus.requerente.codRequerente
      }
      if (pessoaFisica.datNascimento === '1900-01-01') {
        // self.requerente.dataNascimento = null
        // self.dataNascimento = null
      } else {
        self.requerente.dataNascimento = pessoaFisica.datNascimento
        self.dataNascimento = new Date(pessoaFisica.datNascimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
      }

      if (pessoaFisica.pessoaEndereco !== undefined) {
        // mudei para buscar o cep da localização pois segundo o Háquila esse codCepEndFraco é usando apenas para conversões
        // correção de bugs Tarefa #28733
        // alterado por Sérgio
        // self.requerente.numCEP = pessoaFisica.pessoaEndereco.codCepEndFraco
        self.requerente.numCEP = pessoaFisica.pessoaEndereco.localizacao.codCep
      }
      self.paginaStatus.requerente = self.requerente
    },
    preencherPessoaJuridica (pessoaJuridica) {
      var self = this
      self.requerente = {
        nomRequerente: pessoaJuridica.desRazaoSocial,
        dataNascimento: null,
        indSexo: null,
        indTipoDocumento: '',
        indEstadoCivil: null,
        indSituacaoCadastral: 'A',
        indTipoPessoa: self.indTipoPessoa,
        txtEmail: self.verificarSeExisteInformacao('txtEmail', pessoaJuridica),
        numTelefoneMovel: self.verificarSeExisteInformacao('numTelefoneMovel', pessoaJuridica),
        numTelefoneResidencial: self.verificarSeExisteInformacao('numTelefoneResidencial', pessoaJuridica),
        numTelefoneComercial: self.verificarSeExisteInformacao('numTelefoneComercial', pessoaJuridica),
        numNumero: self.verificarSeExisteInformacao('numNumero', pessoaJuridica),
        txtComplemento: self.verificarSeExisteInformacao('txtComplemento', pessoaJuridica),
        numCEP: self.verificarSeExisteInformacao('numCEP', pessoaJuridica),
        nacionalidade: {
          codNacionalidade: self.verificarSeExisteInformacao('codNacionalidade', pessoaJuridica),
          nomNacionalidade: self.verificarSeExisteInformacao('nomNacionalidade', pessoaJuridica)
        },
        logradouro: {
          codLogradouro: self.verificarSeExisteInformacao('codLogradouro', pessoaJuridica),
          nomLogradouro: self.verificarSeExisteInformacao('nomLogradouro', pessoaJuridica)
        },
        bairro: {
          codBairro: self.verificarSeExisteInformacao('codBairro', pessoaJuridica),
          nomBairro: self.verificarSeExisteInformacao('nomBairro', pessoaJuridica)
        },
        municipio: {
          codMunicipio: self.verificarSeExisteInformacao('codMunicipio', pessoaJuridica),
          nomMunicipio: self.verificarSeExisteInformacao('nomMunicipio', pessoaJuridica)
        },
        uf: {
          codUf: self.verificarSeExisteInformacao('codUf', pessoaJuridica),
          nomUf: self.verificarSeExisteInformacao('nomUf', pessoaJuridica)
        }
      }

      // TXT_DOCUMENTO
      if (pessoaJuridica.numCnpj !== undefined && pessoaJuridica.numCnpj !== null && pessoaJuridica.numCnpj !== '') {
        self.requerente.txtDocumento = pessoaJuridica.numCnpj
      }

      if (self.operacao === 'Editar Requerente') {
        self.requerente.codRequerente = self.paginaStatus.requerente.codRequerente
      }

      if (pessoaJuridica.pessoaEndereco !== undefined) {
        // mudei para buscar o cep da localização pois segundo o Háquila esse codCepEndFraco é usando apenas para conversões
        // correção de bugs Tarefa #28733
        // alterado por Sérgio
        // self.requerente.numCEP = pessoaFisica.pessoaEndereco.codCepEndFraco
        self.requerente.numCEP = pessoaJuridica.pessoaEndereco.localizacao.codCep
      }
      self.paginaStatus.requerente = self.requerente
    },
    preencherEndereco (dadosEndereco, viaCep) {
      var self = this
      // OBS: Existem determinados Ceps, principalmente em municipios menores,
      // onde o Api Via CEP não retorna alguns dados, como por exemplo, o Logradouro em Iturama.
      // Por isso é necessário realizar toda essa verificação antes de Setar o valor no PaginaStatus
      // viaCep: true buscou do webservice; false buscou cadUnico
      // VERIFICAR LOGRADOURO
      if (viaCep) {
        if (dadosEndereco.logradouro !== '') {
          self.paginaStatus.requerente.logradouro = { codLogradouro: '', nomLogradouro: dadosEndereco.logradouro }
        } else {
          self.paginaStatus.requerente.logradouro = { codLogradouro: '', nomLogradouro: '' }
          self.$refs['refLogradouro'].limpar()
        }
      } else {
        if (dadosEndereco.bairroLogradouro.logradouro.codLogradouro !== null) {
          self.paginaStatus.requerente.logradouro = {
            codLogradouro: dadosEndereco.bairroLogradouro.logradouro.codLogradouro,
            nomLogradouro: dadosEndereco.bairroLogradouro.logradouro.nomLogradouro
          }
        } else {
          self.paginaStatus.requerente.logradouro = { codLogradouro: '', nomLogradouro: '' }
          self.$refs['refLogradouro'].limpar()
        }
      }

      // VERIFICAR BAIRRO
      if (viaCep) {
        if (dadosEndereco.bairro !== '') {
          self.paginaStatus.requerente.bairro = { codBairro: '', nomBairro: dadosEndereco.bairro }
        } else {
          self.paginaStatus.requerente.bairro = { codBairro: '', nomBairro: '' }
          self.$refs['refBairro'].limpar()
        }
      } else {
        if (dadosEndereco.bairroLogradouro.bairro.codBairro !== null) {
          self.paginaStatus.requerente.bairro = {
            codBairro: dadosEndereco.bairroLogradouro.bairro.codBairro,
            nomBairro: dadosEndereco.bairroLogradouro.bairro.nomBairro
          }
        } else {
          self.paginaStatus.requerente.bairro = { codBairro: '', nomBairro: '' }
          self.$refs['refBairro'].limpar()
        }
      }

      // VERIFICAR CIDADE
      if (viaCep) {
        if (dadosEndereco.localidade !== '') {
          self.paginaStatus.requerente.municipio = { codMunicipio: '', nomMunicipio: dadosEndereco.localidade }
        } else {
          self.paginaStatus.requerente.municipio = { codMunicipio: '', nomMunicipio: '' }
          self.$refs['refCidade'].limpar()
        }
      } else {
        if (dadosEndereco.bairroLogradouro.bairro.municipio.codMunicipio !== null) {
          self.paginaStatus.requerente.municipio = {
            codMunicipio: dadosEndereco.bairroLogradouro.bairro.municipio.codMunicipio,
            nomMunicipio: dadosEndereco.bairroLogradouro.bairro.municipio.nomMunicipio
          }
        } else {
          self.paginaStatus.requerente.municipio = { codMunicipio: '', nomMunicipio: '' }
          self.$refs['refCidade'].limpar()
        }
      }

      // VERIFICAR UF
      if (viaCep) {
        if (dadosEndereco.uf !== '') {
          // Filtra o Array das UF's (Array este preenchido no Load) para retornar apenas o
          // array da UF encontrada pelo Via Cep
          var uf = self.ufArray.filter(function (obj) { return obj.descricao === self.setNomUf(dadosEndereco.uf) })
          // Seta o Código da UF referênte do código do banco cadastro único
          if (uf.length > 0) { uf.forEach(r => { self.paginaStatus.requerente.uf.codUf = r.codigo }) }
        } else self.paginaStatus.requerente.uf.codUf = ''
      } else {
        if (dadosEndereco.bairroLogradouro.bairro.municipio.uf !== null) {
          self.paginaStatus.requerente.uf = {
            codUf: dadosEndereco.bairroLogradouro.bairro.municipio.uf.codUf,
            nomUf: dadosEndereco.bairroLogradouro.bairro.municipio.uf.nomUf
          }
        } else {
          self.paginaStatus.requerente.bairro = { codUf: '', nomUf: '' }
          self.$refs['refUf'].limpar()
        }
      }

      // SET LOGRADOURO
      self.$refs['refLogradouro'].carregar(self.paginaStatus.requerente.logradouro.codLogradouro, self.paginaStatus.requerente.logradouro.nomLogradouro)
      // SET BAIRRO
      self.$refs['refBairro'].carregar(self.paginaStatus.requerente.bairro.codBairro, self.paginaStatus.requerente.bairro.nomBairro)
      // SET CIDADE
      self.$refs['refCidade'].carregar(self.paginaStatus.requerente.municipio.codMunicipio, self.paginaStatus.requerente.municipio.nomMunicipio)
    },
    async buscarPessoaFisicaPorCPF (doc) {
      return new Promise(resolve => {
        let url = api.BUSCAR_PESSOA_FISICA_PELO_CPF.concat('/').concat(doc.toString())
        utilHttp.httpGetCarregando(url, resposta => {
          return resolve(resposta.body)
        })
      })
    },
    async buscarPessoaJuridicaPorCNPJ (doc) {
      return new Promise(resolve => {
        let url = api.BUSCAR_PESSOA_JURIDICA_PELO_CNPJ.concat('/').concat(doc.toString())
        utilHttp.httpGetCarregando(url, resposta => {
          return resolve(resposta.body)
        })
      })
    },
    async buscarEnderecoPessoaPorCodPessoa (codPessoa) {
      return new Promise(resolve => {
        var self = this
        let url = self.apiEndereco.concat('/').concat(codPessoa)
        utilHttp.httpGetCarregando(url, resposta => {
          return resolve(resposta.body)
        })
      })
    },
    buscarPessoa () {
      var self = this
      iniciar()
      async function iniciar () {
        var doc = self.paginaStatus.requerente.txtDocumento
        if (util.validarCampo(doc)) {
          if (self.indTipoPessoa === 'F' && doc !== undefined && doc !== null && doc !== '') {
            if (util.validarCpf(doc)) {
              let pf = await self.buscarPessoaFisicaPorCPF(doc)
              if (util.validarObjeto(pf)) {
                let listaEndereco = await self.buscarEnderecoPessoaPorCodPessoa(pf.pessoa.codPessoa)
                if (await preencherModalPessoa('F', pf, listaEndereco) === true) {
                  self.modalEditar = true
                }
              } else {
                util.exibirToastAviso('O requerente: [' + self.paginaStatus.requerente.nomeDataNascimentoDocumento + '] não está no cadastro de pessoa do município. Salvando a edição, esse cadastro é feito automaticamente!')
              }
            } else {
              util.exibirToastAviso('CPF inválido')
            }
          }
          if (self.indTipoPessoa === 'J' && doc !== undefined && doc !== null && doc !== '') {
            if (util.validarCnpj(doc)) {
              let pj = await self.buscarPessoaJuridicaPorCNPJ(doc)
              if (util.validarObjeto(pj)) {
                let listaEndereco = await self.buscarEnderecoPessoaPorCodPessoa(pj.pessoa.codPessoa)
                if (await preencherModalPessoa('J', pj, listaEndereco) === true) {
                  self.modalEditar = true
                }
              } else {
                util.exibirToastAviso('O requerente: [' + self.paginaStatus.requerente.nomeDataNascimentoDocumento + '] não está no cadastro de pessoa do município. Salvando a edição, esse cadastro é feito automaticamente!')
              }
            } else {
              util.exibirToastAviso('CNPJ inválido')
            }
          }
        } else {
          util.exibirToastAviso('Documento não informado')
        }
      }
      async function preencherModalPessoa (tipoPessoa, pessoa, listaEndereco) {
        return new Promise(resolve => {
          if (tipoPessoa === 'F') {
            self.pessoaFisica = pessoa
          } else {
            self.pessoaJuridica = pessoa
          }
          self.arrayEndereco = listaEndereco
          if (self.arrayEndereco.length === 1) {
            self.arrayEndereco[0].enderecoSelecionado = self.arrayEndereco[0].codPessoaEndereco
          } else {
            self.arrayEndereco.forEach(item => { item.enderecoSelecionado = 0 })
          }
          return resolve(true)
        })
      }
    },
    atualizarRequerente () {
      var self = this
      iniciar()
      function iniciar () {
        var arrayAtualizado = self.arrayEndereco.filter(item => item.enderecoSelecionado === item.codPessoaEndereco)
        if (arrayAtualizado.length > 0) {
          if (self.indTipoPessoa === 'F') {
            self.preencherPessoaFisica(self.pessoaFisica)
          } else {
            self.preencherPessoaJuridica(self.pessoaJuridica)
          }
          setTimeout(() => {
            self.atualizarEndereco(arrayAtualizado)
          }, 200)
        } else {
          util.exibirToastAviso('Endereço não selecionado.')
        }
      }
    },
    atualizarEnderecoRequerente () {
      var self = this
      let arrayAtualizado = self.arrayEndereco2.filter(item => item.enderecoSelecionado === item.codLocalizacao)
      if (arrayAtualizado.length > 0) {
        self.viaCep = false
        let dadosEndereco = {
          bairroLogradouro: {
            logradouro: {
              codLogradouro: arrayAtualizado[0].codLogradouro,
              nomLogradouro: arrayAtualizado[0].logradouro ? arrayAtualizado[0].logradouro.trim() : ''
            },
            bairro: {
              codBairro: arrayAtualizado[0].codBairro,
              nomBairro: arrayAtualizado[0].bairro ? arrayAtualizado[0].bairro.trim() : '',
              municipio: {
                codMunicipio: arrayAtualizado[0].codMunicipio,
                nomMunicipio: arrayAtualizado[0].localidade ? arrayAtualizado[0].localidade.trim() : '',
                uf: {
                  codUf: arrayAtualizado[0].codUf,
                  nomUf: arrayAtualizado[0].uf ? arrayAtualizado[0].uf.trim() : ''
                }
              }
            }
          }
        }
        self.numCEP = arrayAtualizado[0].cep
        self.preencherEndereco(dadosEndereco, false)
        self.arrayEndereco2 = []
        self.modalEndereco = false
        self.termoEnderecoRequerente = ''
      }
    },
    atualizarEndereco (arrayAtualizado) {
      var self = this
      if (arrayAtualizado.length > 0) {
        var dadosEndereco = arrayAtualizado[0]
        self.verificarEnderecoNull = false
        self.viaCep = false
        self.numCEP = dadosEndereco.codCepEndFraco.trim()
        if (dadosEndereco.codLogradouroEndFraco !== null) {
          self.paginaStatus.requerente.logradouro = {
            codLogradouro: dadosEndereco.codLogradouroEndFraco,
            nomLogradouro: dadosEndereco.nomLogradouroEndFraco
          }
        } else {
          self.paginaStatus.requerente.logradouro = { codLogradouro: '', nomLogradouro: '' }
          self.$refs['refLogradouro'].limpar()
        }
        // VERIFICAR BAIRRO
        if (dadosEndereco.codBairroEndFraco !== null) {
          self.paginaStatus.requerente.bairro = {
            codBairro: dadosEndereco.codBairroEndFraco,
            nomBairro: dadosEndereco.nomBairro
          }
        } else {
          self.paginaStatus.requerente.bairro = { codBairro: '', nomBairro: '' }
          self.$refs['refBairro'].limpar()
        }

        // VERIFICAR CIDADE
        if (dadosEndereco.municipio.codMunicipio !== null) {
          self.paginaStatus.requerente.municipio = {
            codMunicipio: dadosEndereco.municipio.codMunicipio,
            nomMunicipio: dadosEndereco.municipio.nomMunicipio
          }
        } else {
          self.paginaStatus.requerente.municipio = { codMunicipio: '', nomMunicipio: '' }
          self.$refs['refCidade'].limpar()
        }

        // VERIFICAR UF
        if (dadosEndereco.municipio.uf !== null) {
          self.paginaStatus.requerente.uf = {
            codUf: dadosEndereco.municipio.uf.codUf,
            nomUf: dadosEndereco.municipio.uf.nomUf
          }
        } else {
          self.paginaStatus.requerente.bairro = { codUf: '', nomUf: '' }
          self.$refs['refUf'].limpar()
        }
        if (util.validarCampo(dadosEndereco.desComplemento)) {
          self.paginaStatus.requerente.txtComplemento = dadosEndereco.desComplemento
        }
        if (util.validarCampo(dadosEndereco.numEndereco)) {
          self.paginaStatus.requerente.numNumero = dadosEndereco.numEndereco
        }
        // SET LOGRADOURO
        self.$refs['refLogradouro'].carregar(self.paginaStatus.requerente.logradouro.codLogradouro, self.paginaStatus.requerente.logradouro.nomLogradouro)
        // SET BAIRRO
        self.$refs['refBairro'].carregar(self.paginaStatus.requerente.bairro.codBairro, self.paginaStatus.requerente.bairro.nomBairro)
        // SET CIDADE
        self.$refs['refCidade'].carregar(self.paginaStatus.requerente.municipio.codMunicipio, self.paginaStatus.requerente.municipio.nomMunicipio)
      }
      if (self.$refs['refNacionalidade']) {
        self.$refs['refNacionalidade'].carregar(self.paginaStatus.requerente.nacionalidade.codNacionalidade, self.paginaStatus.requerente.nacionalidade.nomNacionalidade)
      }
      self.modalEditar = false
      self.arrayEndereco = []
      self.pessoaFisica = {
        nacionalidade: {},
        pessoa: {}
      }
      self.pessoaJuridica = {
        pessoa: {}
      }
    },
    preencherTelefones ({ numTelefone1, numTelefone2, numTelefone3 }) {
      if (numTelefone1) this.paginaStatus.requerente.numTelefoneMovel = numTelefone1
      if (numTelefone2) this.paginaStatus.requerente.numTelefoneResidencial = numTelefone2
      if (numTelefone3) this.paginaStatus.requerente.numTelefoneComercial = numTelefone3
    },
    limparDadosBasicos () {
      var self = this

      // Limpar dados básicos e contato
      self.paginaStatus.requerente = {
        nacionalidade: { codNacionalidade: '', nomNacionalidade: '' },
        logradouro: { codLogradouro: '', nomLogradouro: '' },
        bairro: { codBairro: '', nomBairro: '' },
        municipio: { codMunicipio: '', nomMunicipio: '' },
        uf: { codUf: '', nomUf: '' }
      }
      this.codNacionalidade = ''
      // if (this.$refs['refRazaoSocial']) { this.$refs['refRazaoSocial'].limpar() }
      // if (this.$refs['refNomRequerente']) { this.$refs['refNomRequerente'].limpar() }
      if (this.$refs['refNacionalidade']) { this.$refs['refNacionalidade'].limpar() }
      this.indTipoPessoa = 'F'
      this.numCpf = ''
      this.numRg = ''
      this.numCnpj = ''
      this.numCEP = ''
      this.indSexo = 'I'
      this.indEstadoCivil = 'S'
      this.indSituacaoCadastral = 'A'
      this.tipoDocumento = 'RG'
      this.dataNascimento = ''
    },
    limparEnderecos () {
      var self = this
      // LIMPAR CAMPOS DE ENDEREÇO
      // LOGRADOURO
      self.paginaStatus.requerente.logradouro = { codLogradouro: '', nomLogradouro: '' }
      self.$refs['refLogradouro'].limpar()
      // BAIRRO
      self.paginaStatus.requerente.bairro = { codBairro: '', nomBairro: '' }
      self.$refs['refBairro'].limpar()
      // CIDADE
      self.paginaStatus.requerente.municipio = { codMunicipio: '', nomMunicipio: '' }
      self.$refs['refCidade'].limpar()
      // UF
      self.paginaStatus.requerente.uf.codUf = ''
      self.viaCep = true
    },
    buscarDataNascimento () {
      var self = this

      if (self.paginaStatus.requerente.dataNascimento !== null && self.paginaStatus.requerente.dataNascimento !== undefined) {
        let dn = new Date(self.paginaStatus.requerente.dataNascimento)
        let dia = String(dn.getDate()).padStart(2, '0')
        let mes = String(dn.getMonth() + 1).padStart(2, '0')
        let ano = String(dn.getFullYear())

        var dNascimento = dia + '/' + mes + '/' + ano

        self.dataNascimento = dNascimento
      }
    },
    buscarDadosPessoaFisica () {
      let urlPessoaFisica = ''
      var self = this
      if (self.numCpf.length > 13) {
        let numCpfFormatado = util.removerFormatacao(self.numCpf)
        urlPessoaFisica = api.BUSCAR_PESSOA_FISICA_PELO_CPF.concat('/').concat(numCpfFormatado)
        utilHttp.httpGet(urlPessoaFisica, resposta => {
          if (resposta.body !== null && resposta.body !== '' && resposta.body !== undefined) {
            var pessoaFisica = resposta.body
            self.numCpf = pessoaFisica.numCpf
            let urlPessoaEndereco = self.apiEndereco.concat('/').concat(pessoaFisica.codPessoa)
            utilHttp.httpGetCarregando(urlPessoaEndereco, resposta2 => {
              self.pessoaFisica = resposta.body
              self.arrayEndereco = resposta2.body
              if (self.arrayEndereco.length > 0) {
                self.arrayEndereco[0].enderecoSelecionado = self.arrayEndereco[0].codPessoaEndereco
              }
              self.preencherPessoaFisica(self.pessoaFisica)
              setTimeout(() => {
                var arrayAtualizado = self.arrayEndereco.filter(item => item.enderecoSelecionado === item.codPessoaEndereco)
                self.atualizarEndereco(arrayAtualizado)
              }, 200)
            })
          } else {
            util.exibirToastAviso('Não há dados cadastrados para o CPF digitado.')
          }
        })
      } else {
        util.exibirToastAviso('Preencha o CPF corretamente.')
      }
    },
    chamarPaginaCep () {
      openURL('http://www.buscacep.correios.com.br/sistemas/buscacep/')
    }
  },
  watch: {
    indTipoPessoa: {
      handler (valor) {
        // Ao mudar o tipo de pessoa o tamanho do input não alterava sozinho.
        var self = this

        if (self.paginaStatus.operacao.descricao === 'Novo') {
          setTimeout(() => {
            if (self.$refs['refRazaoSocial']) {
              self.$refs['refRazaoSocial'].limpar()
            }
          }, 100)
          if (valor === 'J' && self.$refs['refTxtDocumento']) {
            self.$refs['refTxtDocumento'].dTamanho = 18
            if (self.paginaStatus.requerente.numTelefoneComercial !== undefined) { self.paginaStatus.requerente.numTelefoneComercial = '' }
            if (self.paginaStatus.requerente.numTelefoneResidencial !== undefined) { self.paginaStatus.requerente.numTelefoneResidencial = '' }
            if (self.paginaStatus.requerente.numTelefoneMovel !== undefined) { self.paginaStatus.requerente.numTelefoneMovel = '' }
            if (self.paginaStatus.requerente.txtEmail !== undefined) { self.paginaStatus.requerente.txtEmail = '' }
            self.numCEP = ''
            self.paginaStatus.requerente.logradouro.codLogradouro = ''
            self.paginaStatus.requerente.numNumero = ''
            self.paginaStatus.requerente.bairro.codBairro = ''
            self.paginaStatus.requerente.txtComplemento = ''
            self.paginaStatus.requerente.municipio.codMunicipio = ''
            self.paginaStatus.requerente.uf.codUf = ''
          } else if (valor === 'F' && self.$refs['refTxtDocumento']) {
            self.$refs['refTxtDocumento'].dTamanho = 14
            self.indSexo = 'I'
            self.indEstadoCivil = 'S'
            self.indSituacaoCadastral = 'A'
            self.dataNascimento = ''
            self.numCpf = ''
            self.paginaStatus.requerente.desFiliacaoPrimeira = ''

            if (self.paginaStatus.requerente.numTelefoneComercial !== undefined) { self.paginaStatus.requerente.numTelefoneComercial = '' }
            if (self.paginaStatus.requerente.numTelefoneResidencial !== undefined) { self.paginaStatus.requerente.numTelefoneResidencial = '' }
            if (self.paginaStatus.requerente.numTelefoneMovel !== undefined) { self.paginaStatus.requerente.numTelefoneMovel = '' }
            if (self.paginaStatus.requerente.txtEmail !== undefined) { self.paginaStatus.requerente.txtEmail = '' }

            self.numCEP = ''
            self.paginaStatus.requerente.logradouro.codLogradouro = ''
            self.paginaStatus.requerente.numNumero = ''
            self.paginaStatus.requerente.bairro.codBairro = ''
            self.paginaStatus.requerente.txtComplemento = ''
            self.paginaStatus.requerente.municipio.codMunicipio = ''
            self.paginaStatus.requerente.uf.codUf = ''
          } else {
            self.indEstadoCivil = 'S'
            self.indSituacaoCadastral = 'A'
            self.tipoDocumento = 'RG'
          }
        } else {
          if (valor === 'J' && self.$refs['refTxtDocumento']) {
            self.$refs['refTxtDocumento'].dTamanho = 18
            self.numCnpj = self.paginaStatus.requerente.txtDocumento
          } else if (valor === 'F' && self.$refs['refTxtDocumento']) {
            self.$refs['refTxtDocumento'].dTamanho = 14
            self.numCpf = self.paginaStatus.requerente.txtDocumento
          } else {
            self.$refs['refTxtDocumento'].dTamanho = 14
          }
        }
      }
    },
    tipoDocumento: {
      handler (valor) {
        var self = this
        if (valor === 'RG' && self.$refs['refTxtDocumentoOutro']) {
          self.$refs['refTxtDocumentoOutro'].dTamanho = 16
        } else if (valor === 'NIS' && self.$refs['refTxtDocumentoOutro']) {
          self.$refs['refTxtDocumentoOutro'].dTamanho = 11
        } else if (valor === 'PAS' && self.$refs['refTxtDocumentoOutro']) {
          self.$refs['refTxtDocumentoOutro'].dTamanho = 10
        }

        // Ao mudar o tipo de documento o tamanho do input não alterava sozinho.
      }
    },
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    numCEP: {
      // RN012 - Ao usuário digitar o CEP, o sistema deverá preencher a
      // localização (os campos Logradouro, Número, Bairro, Complemento, Cidade e UF)
      // de acordo com os dados cadastrados no Sistema de Gestão de Pessoas.

      // Caso o CEP não esteja cadastrado no Sistema de Gestão de Pessoas
      // o sistema deverá tentar localizar o CEP e preencher os seus respectivos campos pelo
      // Web Service ViaCEP.
      handler (valor) {
        var self = this
        if (self.numCEP !== undefined && self.numCEP !== '' && self.numCEP !== null) {
          self.paginaStatus.requerente.numCEP = valor
          let cep = util.removerFormatacao(valor.toString())
          if (cep.length === 8 && self.viaCep === true) {
            // Tentar Buscar o CEP no Cadastro Único. Na tabela Localização
            let urlBuscarCep = api.BUSCAR_TODAS_LOCALIZACOES_PELO_CEP + '/' + cep.toString()
            utilHttp.httpGet(urlBuscarCep, resposta => {
              // Se existir dados já cadastrados no sistema de gestão de pessoas
              if (resposta.body.length > 0) {
                self.termoEnderecoRequerente = ''
                self.arrayEndereco2 = resposta.body
                if (resposta.body.length === 1) {
                  // var localizacao = resposta.body[0]
                  self.atualizarEnderecoSelecionado2(0)
                  setTimeout(() => {
                    self.atualizarEnderecoRequerente()
                  }, 100)
                  // self.preencherEndereco(localizacao, false)
                  // self.verificarEnderecoNull = true
                  // self.desabilitarEnderecos()
                } else {
                  self.modalEndereco = true
                }
                // Se não existir a localização, utilizar a api Via Cep
              } else {
                // URL do Web Api ViaCep
                let urlViaCep = 'https://viacep.com.br/ws/' + cep + '/json/'
                utilHttp.httpGetCep(urlViaCep, resposta => {
                  // Caso encontre
                  if (resposta.body !== null && resposta.body !== '' && resposta.body !== undefined && resposta.body.erro !== true) {
                    var dadosViaCep = resposta.body
                    self.preencherEndereco(dadosViaCep, true)
                    self.verificarEnderecoNull = true
                    self.desabilitarEnderecos()
                  }
                })
              }
            })
          } else if (self.verificarEnderecoNull) {
            self.limparEnderecos()
            self.desabilitarEnderecos()
          }
        } else {
          self.limparEnderecos()
        }
      }
    }
  },
  mounted () {
    // Load
    setTimeout(() => {
      var self = this
      self.load = true
      if (self.$route.params.paginaStatus) {
        self.paginaStatus = self.$route.params.paginaStatus
        if (!self.paginaStatus.teste) {
          self.paginaStatus.caminhoMigalha.push({
            icone: self.paginaStatus.operacao.icone,
            descricao: self.paginaStatus.operacao.descricao,
            rotaNome: 'requerente'
          })
        } else {
          // self.paginaStatus.caminhoMigalha =
          this.paginaStatus.caminhoMigalha2 = JSON.parse(JSON.stringify(this.paginaStatus.caminhoMigalha))
          this.paginaStatus.caminhoMigalha2 = undefined
        }
      } else if (util.recuperarDoStorage(self.chaveLocalStorage)) {
        self.paginaStatus = util.recuperarDoStorage(self.chaveLocalStorage)
        self.atualizarCampos()
      }
      self.carregarSelects()

      // RN006, RN007, RN008, RN009, RN010 -> em caso de Novo Registro ->
      // Set valores default dos combos

      if (self.paginaStatus.operacao.descricao === 'Novo') {
        self.indTipoPessoa = 'F'
        self.indSexo = 'I'
        self.indEstadoCivil = 'S'
        self.indSituacaoCadastral = 'A'
        self.operacao = 'Salvar'
        self.tipoDocumento = 'RG'
        self.viaCep = true
      } else {
        // Caso editando ou visualizando -> Set valores do Item
        self.viaCep = false
        self.indTipoPessoa = self.paginaStatus.requerente.indTipoPessoa
        self.indSexo = self.paginaStatus.requerente.indSexo
        self.tipoDocumento = self.paginaStatus.requerente.indTipoDocumento
        self.indEstadoCivil = self.paginaStatus.requerente.indEstadoCivil
        self.indSituacaoCadastral = self.paginaStatus.requerente.indSituacaoCadastral
        self.numCEP = self.paginaStatus.requerente.numCEP
        self.operacao = 'Editar Requerente'
        self.buscarDataNascimento()
        self.atualizarCampos()
        self.desabilitarEnderecos()
      }
    }, 100)
  },
  components: { GBreadcrumb, GInput, GDatatable, GFab, GAutocomplete, GSelect, GDatepicker, GDateInput }
}
</script>
